/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__constraints__no_vignette = /** @type {(inputs: {}) => string} */ () => {
	return `Ohne Vignette`
};

const en_itinerary__options__constraints__no_vignette = /** @type {(inputs: {}) => string} */ () => {
	return `Avoid toll vignettes`
};

const es_itinerary__options__constraints__no_vignette = /** @type {(inputs: {}) => string} */ () => {
	return `Evitar compra de viñeta`
};

const fr_itinerary__options__constraints__no_vignette = /** @type {(inputs: {}) => string} */ () => {
	return `Pas d'achat de vignette`
};

const it_itinerary__options__constraints__no_vignette = /** @type {(inputs: {}) => string} */ () => {
	return `Senza acquisto di bollino autostradale`
};

const nl_itinerary__options__constraints__no_vignette = /** @type {(inputs: {}) => string} */ () => {
	return `Geen vignet kopen`
};

const pt_itinerary__options__constraints__no_vignette = /** @type {(inputs: {}) => string} */ () => {
	return `Sem compra de selos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_vignette = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__constraints__no_vignette(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__constraints__no_vignette", locale)
	if (locale === "de") return de_itinerary__options__constraints__no_vignette(inputs)
	if (locale === "en") return en_itinerary__options__constraints__no_vignette(inputs)
	if (locale === "es") return es_itinerary__options__constraints__no_vignette(inputs)
	if (locale === "fr") return fr_itinerary__options__constraints__no_vignette(inputs)
	if (locale === "it") return it_itinerary__options__constraints__no_vignette(inputs)
	if (locale === "nl") return nl_itinerary__options__constraints__no_vignette(inputs)
	return pt_itinerary__options__constraints__no_vignette(inputs)
};